import type { ReactElement } from 'react';
import type { Disabled } from 'components/dataCreationForms/withInputForm/statefulInputsWrapper/types';

export enum InspectionCommentLabelVariant {
  floating = 'floating',
  section = 'section',
}

export interface CollapsibleInspectionCommentProps {
  formKey: string;
  fallbackValue?: string;
  disabled?: Disabled;
  /**
   * `floating` — label on the field border (e.g. general inspection comment after score).
   * `section` — no in-field label; parent renders a section heading above.
   */
  labelVariant?: InspectionCommentLabelVariant;
  /** Increment to programmatically expand and focus the editor. */
  focusSignal?: number;
  children: ReactElement;
}
